import { ExcelFileContentStatusEnum } from "./types";




const ExcelStatusData: Record<ExcelFileContentStatusEnum, string> = {
  [ExcelFileContentStatusEnum.PROCESSED]: "excel.status.processed",
  [ExcelFileContentStatusEnum.PENDING]: "excel.status.pending",
  [ExcelFileContentStatusEnum.FAILED]: "excel.status.failed",
  [ExcelFileContentStatusEnum.PROCESSED_WITH_ERRORS]: "excel.status.processedWithError",
  [ExcelFileContentStatusEnum.PARTIALLY_PROCESSED]: "excel.status.partiallyProcessed",
  [ExcelFileContentStatusEnum.PROCESSING]: "excel.status.processing",
};
const excelStatusColorMap: Record<ExcelFileContentStatusEnum, string> = {
  [ExcelFileContentStatusEnum.PROCESSED]: "green",
  [ExcelFileContentStatusEnum.PENDING]: "orange",
  [ExcelFileContentStatusEnum.FAILED]: "red",
  [ExcelFileContentStatusEnum.PROCESSED_WITH_ERRORS]: "yellow",
  [ExcelFileContentStatusEnum.PARTIALLY_PROCESSED]: "blue",
  [ExcelFileContentStatusEnum.PROCESSING]: "lightgreen",
};
export enum ExcelFileStatusEnum {
  PROCESSED = 1,
  PENDING = 2,
  PARTIALLY_PROCESSED = 3,
  PROCESSED_WITH_ERRORS = 4,
  PROCESSING = 5,
  FAILED = 6,
}
const ExcelDetailsStatusData: Record<ExcelFileStatusEnum, string> = {
  [ExcelFileStatusEnum.PROCESSED]: "excel.status.processed",
  [ExcelFileStatusEnum.PENDING]: "excel.status.pending",
  [ExcelFileStatusEnum.FAILED]: "excel.status.failed",
  [ExcelFileStatusEnum.PROCESSED_WITH_ERRORS]: "excel.status.processedWithError",
  [ExcelFileStatusEnum.PROCESSING]: "excel.status.processing",
  [ExcelFileStatusEnum.PARTIALLY_PROCESSED]: "excel.status.partiallyProcessed",
};
const excelDetailStatusColorMap: Record<ExcelFileStatusEnum, string> = {
  [ExcelFileStatusEnum.PROCESSED]: "green",
  [ExcelFileStatusEnum.PENDING]: "orange",
  [ExcelFileStatusEnum.FAILED]: "red",
  [ExcelFileStatusEnum.PROCESSING]: "green.100",
  [ExcelFileStatusEnum.PROCESSED_WITH_ERRORS]: "red.100",
  [ExcelFileStatusEnum.PARTIALLY_PROCESSED]: "orange.100",
};

export { excelStatusColorMap, ExcelStatusData ,excelDetailStatusColorMap,ExcelDetailsStatusData};
